import { ResponseError } from "../defaults";

export const getResponseErrorDetail = (error: unknown) => {
    if (error instanceof ResponseError) {
        if (error.problem?.detail || error.problem?.title) {
            return error.problem?.detail || error.problem?.title;
        }
    }

    if (error instanceof Error) {
        return error.message;
    }

    return String(error);
};
